import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Card = styled(Box)({
    backgroundColor: '#202020',
    borderRadius: '12px',
    padding: '1.5rem',
});

const Cell = styled(TableCell)({
    color: '#fff',
    fontSize: '0.85rem',
    whiteSpace: 'nowrap',
});

const statusColor = (status) => {
    switch (status) {
        case 'Completed': return '#12c099';
        case 'PickedUp': return '#ffa726';
        case 'Assigned': return '#42a5f5';
        case 'Cancelled': return '#ef5350';
        default: return '#9e9e9e';
    }
};

const CourierDeliveries = ({ firebaseUid }) => {
    const [deliveries, setDeliveries] = useState([]);

    useEffect(() => {
        const fetchDeliveries = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/courier/${firebaseUid}/deliveries`
                );

                // ✅ THIS IS THE FIX
                setDeliveries(Array.isArray(res.data.data) ? res.data.data : []);
            } catch (error) {
                console.error('Error fetching deliveries:', error);
                setDeliveries([]);
            }
        };

        fetchDeliveries();
    }, [firebaseUid]);

    return (
        <Card>
            <Typography variant="h6" gutterBottom>
                Deliveries
            </Typography>

            {deliveries.length === 0 ? (
                <Typography variant="body2" color="#9e9e9e">
                    No deliveries found.
                </Typography>
            ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <Cell>Session</Cell>
                            <Cell>Status</Cell>
                            <Cell>Payout</Cell>
                            <Cell>Completed</Cell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {deliveries.map((d, idx) => (
                            <TableRow key={idx}>
                                <Cell>{d.sessionId || '—'}</Cell>
                                <Cell>
                                    <Chip
                                        size="small"
                                        label={d.status}
                                        sx={{
                                            backgroundColor: statusColor(d.status),
                                            color: '#000',
                                        }}
                                    />
                                </Cell>
                                <Cell>${d.payoutAmount || 0}</Cell>
                                <Cell>
                                    {d.completedAt
                                        ? new Date(d.completedAt).toLocaleDateString()
                                        : '—'}
                                </Cell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Card>
    );
};

export default CourierDeliveries;
